'use client';

import AuthProviderButton from '@/features/auth/components/AuthProviderButton';

export default function GoogleAuthButton({
  disabled = false,
  onClick,
  label = 'Continue with Google',
}) {
  return (
    <AuthProviderButton
      provider="google"
      disabled={disabled}
      onClick={onClick}
      label={label}
      icon="/icons/googleIcon.svg"
    />
  );
}
